import styled from 'styled-components';

export default styled.div`
  background-color: ${props => props.negative ? 'black' : 'white'};
  color: ${props => props.negative ? 'white' : 'black'};
`